/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

/* eslint-disable indent */
    'use strict';
    var Flights = require('../apps/app.flights');
    Odigeo.defineWidget('accommodation_search_manager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            mode: 'default',
            dataUrl: 'accommodation/upsell/search',
            dataResultsUrl: 'accommodation/upsell/getaccommodationresults',
            propensityUrl: 'accommodation/upsell/getpropensity',
            postbookingUrl: 'accommodationpostbooking/upsell/getpostbooking',
            trackNagUrl: 'accommodation/trackNag',
            defaults: {
                itinerarySearchRequest: '',
                accommodationSearchRequest: '',
            },

            url: function() {
                return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
            },

            getResultsUrl: function() {
                return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataResultsUrl);
            },

            getPropensityUrl: function() {
                return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.propensityUrl);
            },

            getPostBookingUrl: function() {
                return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.postbookingUrl);
            },

            getTrackNagUrl: function() {
                return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.trackNagUrl);
            },

            getAccommodationResults: function() {
                return this.fetch({
                    url: this.getResultsUrl(),
                    success: Odigeo._.bind(this.successGetResults, this),
                    error: Odigeo._.bind(this.errorGetResults, this),
                });
            },

            sendTrackNagAccommodation: function() {
                return this.fetch({
                    url: this.getTrackNagUrl(),
                    method: 'POST',
                });
            },

            successGetResults: function(model, results) {
                if (!Odigeo._.isNull(results) && !Odigeo._.isUndefined(results)) {
                    Odigeo.trigger(this.widget.id + ':resultsLoaded', results);
                } else {
                    Odigeo.trigger(this.widget.id + ':resultsNotAvailable');
                }
            },

            successGetPropensity: function(model, showIP) {
                Odigeo.trigger(this.widget.id + ':successGetPropensity', showIP);
            },

            errorGetResults: function() {
                Odigeo.trigger(this.widget.id + ':resultsNotAvailable');
            },

            getRequestParams: function(data) {
                return this.mode === 'newSearch'
                    ? Flights.convertXsellNewSearchAccommodationRequest(data)
                    : Flights.convertXsellAccommodationRequest(data);
            },

            getPropensity: function(data, mode) {
                this.mode = mode;
                var params = this.getRequestParams(data);
                this.clear().save(params, {
                    url: this.getPropensityUrl(),
                    success: Odigeo._.bind(this.successGetPropensity, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                });

                Odigeo.Session.set('accommodationSearchParameters', JSON.stringify(params));
            },

            search: function(data, timeout, mode) {
                this.mode = mode;
                const params = this.getRequestParams(data);
                this.clear().save(params, {
                    timeout: timeout,
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                });

                Odigeo.Session.set('accommodationSearchParameters', JSON.stringify(params));
            },

            postBooking: function(requestParams, isNewSearch) {
                if (isNewSearch) {
                    requestParams = this.prepareRequestParams(requestParams);
                    this.mode = 'newSearch';
                } else {
                    this.mode = 'accommodationPostBooking';
                }
                this.clear().save(requestParams, {
                    url: this.getPostBookingUrl(),
                    success: Odigeo._.bind(this.requestSuccessHandler, this),
                    error: Odigeo._.bind(this.requestErrorHandler, this),
                });
                Odigeo.Session.set('accommodationSearchParameters', JSON.stringify(requestParams));
            },

            prepareRequestParams: function(requestParams) {
                var accommodationSearchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('accommodationSearchParameters'));
                var accommodationSearchRequest = Flights.convertXsellNewSearchAccommodationRequest(requestParams);
                requestParams = accommodationSearchRequest;
                requestParams.accommodationSearchRequest.searchType = 'POST_BOOKING';
                requestParams.itinerarySearchRequest = accommodationSearchParameters.itinerarySearchRequest;
                return requestParams;
            },

            afterLoadData: function() {
                Odigeo.trigger(this.widget.id + ':dataLoaded');
            },

            requestSuccessHandler: function(model, data) {
                let successEvent;
                if (this.mode === 'newSearch') {
                    successEvent = ':successNewAccommodationSearch';
                } else if (this.mode === 'accommodationPostBooking') {
                    successEvent = ':successPostBookingAccommodationSearch';
                } else {
                    successEvent = ':successAccommodationSearch';
                }
                Odigeo.trigger(this.widget.id + successEvent, data);
            },

            requestErrorHandler: function(model, xhr) {
                const isTimeoutError = xhr.statusText === 'timeout';
                let errorEvent;
                if (this.mode === 'newSearch') {
                    errorEvent = ':errorNewAccommodationSearch';
                } else if (this.mode === 'accommodationPostBooking') {
                    errorEvent = ':errorNewAccommodationSearch';
                } else {
                    errorEvent = ':errorAccommodationSearch';
                }

                Odigeo.trigger(this.widget.id + errorEvent, isTimeoutError);
            },
        }),

        search: function(data, timeout, mode) {
            this.model.search(data, timeout, mode);
        },

        postBooking: function(data, mode) {
            this.model.postBooking(data, mode);
        },

        getAccommodationResults: function() {
            this.model.getAccommodationResults();
        },

        getPropensity: function(data, mode) {
            this.model.getPropensity(data, mode);
        },

        sendTrackNagAccommodation: function() {
            this.model.sendTrackNagAccommodation();
        },
    }));
